import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { PetItem } from 'components/ClientForm/PetItem/PetItem';
import { PetForm } from 'types/FormsInvitation';
import { Button } from 'components/UI/Button/Button';
import React from 'react';

import classes from './PetList.module.scss';

interface PetListProps {
    pets: PetForm[];
    selectedPetUuid: string | null;
    onSelectPet: (petUuid: string) => void;
    onClickAddPet: () => void;
}

export const PetList: React.FC<PetListProps> = props => {
    return (
        <div className={classes.root}>
            <h1 className="h2 underlined w-full">Your Pets</h1>

            <div className={classes.petList}>
                {props.pets.map(pet => (
                    <PetItem
                        key={pet.uuid}
                        pet={pet}
                        isSelected={props.selectedPetUuid === pet.uuid}
                        onSelect={() => props.onSelectPet(pet.uuid)}
                    />
                ))}
            </div>

            <Button variant="link" className={classes.addPetButton} onClick={props.onClickAddPet}>
                <FontAwesomeIcon icon={faPlus} />

                <span>Add new pet</span>
            </Button>
        </div>
    );
};
